import React, { useState } from "react";
import axios from "axios";

const AddAdminModal = ({ Ip, showModal, closeModal,onUserAdded }) => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    number: "",
    password: "",
    fullname: "",
    accessLvl: 3
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAdd = async () => {
    setLoading(true);
    setMessage("");
    setError(false);

    try {
      const form = new FormData();
      for (const key in formData) form.append(key, formData[key]);

      const res = await axios.post(`${Ip}/Dashboard/add_admin_user.php`, form, {
        withCredentials: true
      });

      if (res.data.status) {
        setMessage(res.data.message);
        setError(false);
        setFormData({
          username: "",
          email: "",
          number: "",
          password: "",
          fullname: "",
          accessLvl: 3
        });
        closeModal();
        if (onUserAdded) onUserAdded();
      } else {
        setMessage(res.data.message);
        setError(true);
      }
    } catch (err) {
      setMessage("Server error");
      setError(true);
    }

    setLoading(false);
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-light-surface dark:bg-dark-surface p-6 rounded-xl w-full max-w-lg">
        <h2 className="text-lg font-bold mb-4">Add User</h2>

        {message && (
          <p className={`mb-3 ${error ? "text-red-500" : "text-green-500"}`}>
            {message}
          </p>
        )}

        <div className="space-y-3">
          <input
            name="username"
            value={formData.username}
            onChange={handleChange}
            placeholder="Username"
            className="w-full p-2 rounded border bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-700"
            required
          />
          <input
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            className="w-full p-2 rounded border bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-700"
            required
          />
          <input
            name="fullname"
            value={formData.fullname}
            onChange={handleChange}
            placeholder="Full Name"
            className="w-full p-2 rounded border bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-700"
            required
          />
          <input
            name="number"
            type="number"
            value={formData.number}
            onChange={handleChange}
            placeholder="Phone Number"
            className="w-full p-2 rounded border bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-700"
            required
          />
          <input
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Password"
            className="w-full p-2 rounded border bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-700"
            required
          />
          <select
            name="accessLvl"
            value={formData.accessLvl}
            onChange={handleChange}
            className="w-full p-2 rounded border text-gray-700"
          >
            <option value={1}>Admin</option>
            <option value={2}>Editor</option>
            <option value={3}>Viewer</option>
          </select>
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={closeModal}
            className="px-4 py-2 border rounded-lg hover:bg-gray-700 dark:hover:bg-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={handleAdd}
            disabled={loading}
            className="bg-light-brand dark:bg-dark-brand text-white px-4 py-2 rounded-lg hover:opacity-90 disabled:opacity-50"
          >
            {loading ? "Adding..." : "Add User"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAdminModal;